/**
 * Created by zhangrp on 2018/4/3.
 */

import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';

import SwbServicerForComnSelect from './ServicerForComnSelect';
Vue.regist(SwbServicerForComnSelect);

//选择服务商公共组件
/**
 * @param self
 * @param showContractServicer 展示合同服务商，不传默认不展示
 * @param showDefServicer 展示默认，不传默认不展示
 * @param showRelServicer 展示备选关联服务商，不传默认不展示
 * @param showOthersServicer 展示备选其他服务商，不传默认不展示
 * @param showAllServicer 展示全部服务商，不传默认展示
 * @param multiSelect 多选框，不传默认多选
 * @param filter 列表过滤条件
 * @param initCheckedItem 单选初始选择项
 * @param initCheckedItems 多选初始选择项
 * @param callback
 */
export function openServicerSelectComnDlg(self, params, callback) {
    let showContract = params.showContract || false;
    let showDef = params.showDef || false;
    let showServcContract = params.showServcContract || false;
    let servcType = params.servcType;
    let devcGroupId = params.devcGroupId || null;
    let retailerComId = params.retailerComId || null;
    let devcDefIds = params.devcDefIds || [];
    let showOrder = params.showOrder || false;
    let showAmbilateralBizRel = params.showAmbilateralBizRel || false;
    let showBizRel = params.showBizRel || false;
    let showAdverseBizRel = params.showAdverseBizRel || false;
    let showNoScoreBizRel = params.showNoScoreBizRel || false;
    let showShieldedBizRel = params.showShieldedBizRel || false;
    let showAll = params.showAll || false;
    let multiSelect = params.multiSelect == null ? true : params.multiSelect;
    let multiSelectDisabled = params.multiSelectDisabled || false;
    let filter = params.filter || {};
    let initCheckedId = params.initCheckedId || null;
    let initCheckedIds = params.initCheckedIds || [];
    let warnMessage = params.warnMessage == null ? true : params.warnMessage; // 警告提示（没有选择提示）
    if(!showContract && !showOrder && !showAmbilateralBizRel && !showBizRel && !showAdverseBizRel && !showNoScoreBizRel && !showShieldedBizRel && !showAll && !showDef) {
        MsgBox.warning("至少展示一种类型的服务商!");
        return;
    }
    let theDlg = Vue.$showDialog({
        title: '服务商 - 选择',
        width: '60%',
        height: '80%',
        showCloseBtn: true,
        template: '<div>' +
        '<swb-servicer-for-comn-select :servcType="servcType" :devcGroupId="devcGroupId" :retailerComId="retailerComId" :devcDefIds="devcDefIds" :showDef="showDef" :showServcContract="showServcContract" :showContract="showContract" :showOrder="showOrder" :showAmbilateralBizRel="showAmbilateralBizRel"' +
        ':showBizRel="showBizRel" :showAdverseBizRel="showAdverseBizRel" :showNoScoreBizRel="showNoScoreBizRel" :showShieldedBizRel="showShieldedBizRel"' +
        ':showAll="showAll" :multiSelect="multiSelect" :multiSelectDisabled="multiSelectDisabled"  :filter="filter" :initCheckedId="initCheckedId"' +
        ':initCheckedIds="initCheckedIds" :warnMessage = "warnMessage" ref="swb_servicer_for_comn_select"></swb-servicer-for-comn-select>' +
        '</div>',
        data: {
            showDef: showDef,
            showServcContract: showServcContract,
            showContract: showContract,
            showOrder: showOrder,
            showAmbilateralBizRel: showAmbilateralBizRel,
            showBizRel: showBizRel,
            showAdverseBizRel: showAdverseBizRel,
            showNoScoreBizRel: showNoScoreBizRel,
            showShieldedBizRel: showShieldedBizRel,
            showAll: showAll,
            multiSelect: multiSelect,
            multiSelectDisabled: multiSelectDisabled,
            filter: filter,
            initCheckedId: initCheckedId,
            initCheckedIds: initCheckedIds,
            warnMessage: warnMessage,
            servcType: servcType,
            devcGroupId: devcGroupId,
            retailerComId: retailerComId,
            devcDefIds: devcDefIds,
        },
        okClicked: function () {
            let result = this.$refs.swb_servicer_for_comn_select.getDlgResult() || {};
            if(result.type == "info") {
                //
                let returnData = {};
                returnData.checkedIds = result.checkedIds || [];
                returnData.checkedId = result.checkedId || null;
                returnData.checkedList = result.data || [];
                callback(returnData);
                return true;
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        cancelClicked: function () {
        },
        methods: {}
    });
}

/**
 *
 * @param queryFilter
 * @param callbackFunc
 */
import SwbServicerEngineerListForSelect from './ServicerEngineerListForSelect';
Vue.regist(SwbServicerEngineerListForSelect);
// 服务工程师 - 选择
export function openServicerEngineerListForSelectListDlg(params, callback) {
    let servicerShopId = params.servicerShopId || null;
    let merchantId = params.merchantId || null;
    let isRadio = false;
    if(!Utils.isNoB(params.isRadio)) {
        isRadio = params.isRadio;
    }
    Vue.$showDialog({
        title: '服务工程师 - 选择',
        width: 1200,
        height: 750,
        showCloseBtn: true,
        template: '<swb-servicer-engineer-list-for-select :merchantId="merchantId" :isRadio="isRadio" :servicerShopId="servicerShopId" ref="swb_servicer_engineer_list_select"></swb-servicer-engineer-list-for-select>' +
        '</div>',
        data: {
            servicerShopId: servicerShopId,
            isRadio: isRadio,
            merchantId: merchantId,
        },
        okClicked: function () {
            let result = this.$refs.swb_servicer_engineer_list_select.getDlgResult() || {};
            if(result.type === 'info') {
                let engineerList = result.data;
                //
                callback(engineerList);
            } else {
                Toast.show(result.message);
                return false;
            }

        }
    });
}

//
import SwbServicerComListForSelect from './ServicerComListForSelect';
Vue.regist(SwbServicerComListForSelect);
export function openServicerComListForSelectDlg(queryFilter, callbackFunc) {
    let checkedComList = queryFilter['checkedComList'] || [];
    let checkBox = queryFilter['checkBox'];
    let merchantId = queryFilter['merchantId'];
    let comLevl = queryFilter['comLevl'];
    let comId = queryFilter['comId'];
    let shopFlag = queryFilter['shopFlag'] != null ? queryFilter['shopFlag'] : null;
    let title = queryFilter['title'] ? queryFilter['title'] : '服务商机构 - 选择';
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1000,
        height: 700,
        showCloseBtn: true,
        template: '<swb-servicer-com-list-for-select :comId="comId" :comLevel="comLevl" :shopFlag="shopFlag" :checkBox="checkBox" :checkedComList="checkedComList" :merchantId="merchantId" ref="swb_servicer_com_list_for_select"></swb-servicer-com-list-for-select>',
        data: {
            checkBox: checkBox,
            checkedComList: checkedComList,
            merchantId: merchantId,
            comId: comId,
            comLevl: comLevl,
            shopFlag: shopFlag,
        },
        okClicked: function () {
            let selfDlg = this;
            let result = selfDlg.$refs.swb_servicer_com_list_for_select.getDlgResult() || {};
            if(result.type === 'info') {
                let retailerComList = result.data;
                callbackFunc(retailerComList, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/servicer/selectDlg.js
// module id = 65
// module chunks = 0